// resolve storeId แล้ว migrate run mode ให้เสร็จก่อนใครแตะ
// (รันต่อจาก computerIdentity ซึ่งไม่อ่านโหมด — ดู modules/core/index.ts)
//
// ลำดับที่ต้องได้:
//   1. plugin นี้ (enforce: 'pre' + async → nuxt จะ await ให้จบก่อน mount app)
//   2. pinia plugin ของ pos/thermalPrinter ที่เรียก getMode() ตอน jobs store ถูกสร้าง
//   3. bootstrap.init() / bootstrap.run() ในหน้า index
//
// ได้แบบนี้ถึงจะไม่ต้องรอหลายวันให้เครื่องหน้าร้านทยอย migrate เอง — เครื่องไหน
// เปิดแอปหลังจาก deploy ก็ได้ค่าใหม่ครบตั้งแต่ boot แรก
//
// ทุกอย่างห่อ try/catch: migration ล้มเหลวห้ามทำให้แอปเปิดไม่ขึ้น อย่างแย่ที่สุด
// คือได้ UNASSIGNED แล้วผู้ใช้เลือกโหมดเองอีกที
import "../../../firebaseInstance";
import { resolveStoreId } from "../composables/useStoreIdentity";
import { migrateRunMode } from "../composables/useRunningMode";

export default defineNuxtPlugin({
  name: "run-mode-migration",
  enforce: "pre",
  parallel: false,
  async setup() {
    try {
      const storeId = await resolveStoreId();
      // ยังไม่ login (หน้า /login, /signup) — ไม่มีอะไรให้ migrate
      if (!storeId) return;

      migrateRunMode(storeId);
    } catch (error) {
      console.warn("[runMode] migration ข้ามไป", error);
    }
  },
});
